export default __webpack_public_path__ + "static/media/about-ingame.23c466b9.svg";